import "./../App.css";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import { Link } from "react-router-dom";

function About() {
  return (
    <div className="about2">
      <div className="about">
        {/* <!-- Start Page Title Area --> */}
        <div className="banner-area testimonials">
          <div className="d-table">
            <div className="d-table-cell">
              <div className="container">
                <div className="page-title-content">
                  <h2>About</h2>
                  <ul>
                    <li key={`icon1`}>
                      <Link to="">Home</Link>
                      <i className="flaticon-fast-forward"></i>
                      <p className="active">About</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <!-- End Page Title Area --> */}
      </div>
      {/* <!-- Testimonials --> */}
      <div className="testimonials-area">
        <div className="container">
          <div className="section-tittle text-center">
            <h2>About Us</h2>
            <p>
              Achiever’s Hub Senior Secondary School, truly a house of
              achievers, warmly welcomes your child into a dynamic and enriching
              world of education. Our school provides a joyful, secure, and
              inspiring environment where young learners are encouraged to
              explore, grow, and excel academically as well as personally.
            </p>
            <p>
              We firmly believe that every child is endowed with immense
              potential. When guided with care, values, and the right
              opportunities, this potential blossoms into excellence and
              success. Our dedicated approach to holistic education nurtures
              intellectual curiosity, moral integrity, creativity, and
              confidence in every student.
            </p>{" "}
            <p>
              The progress and future of a nation rest upon its youth, and the
              quality of education they receive shapes that future. At
              Achiever’s Hub, we view education as a meaningful investment in
              the present—one that builds responsible, capable, and visionary
              leaders for tomorrow.
            </p>
          </div>
        </div>
      </div>

      {/* <!-- End Testimonials --> */}
    </div>
  );
}

export default About;
